// English copy. Keys mirror sr.js; English plurals only use "one" and "many".
const en = {
  common: {
    skip: "Skip to content",
    call: "Call",
    callNow: "Call now",
    callShort: "Call",
    sendInquiry: "Send an inquiry",
    sendInquiryShort: "Inquire",
    allUnits: "All apartments",
    seeUnits: "View apartments",
    seeFreeUnits: "See available apartments",
    loading: "Loading…",
    priceOnRequest: "On request",
    openMaps: "Open in Google Maps",
    notRequired: "optional",
    close: "Close",
    home: "Home",
    backHome: "Back to home",
    company: "Tehnočin DOO Invest",
    city: "Beočin",
  },
  nav: {
    offer: "Buildings",
    units: "Apartments",
    process: "How we build",
    about: "About us",
    location: "Location",
    faq: "FAQ",
    contact: "Contact",
    main: "Main navigation",
    mobile: "Mobile navigation",
    footer: "Footer links",
    open: "Open menu",
    close: "Close menu",
    logoHome: "Tehnočin DOO, home",
  },
  lang: {
    label: "Language",
    switchTo: "View the site in {name}",
  },
  home: {
    hero: {
      eyebrow: "New build · Beočin, Serbia",
      title: "New apartments on Beočin Square",
      lead: "Lamela A and Lamela B are residential and commercial buildings in central Beočin, near Novi Sad. We are the family company building them, and you buy your apartment directly from us.",
      art: "Pixel animation: a building rising floor by floor next to a crane",
    },
    facts: {
      label: "Project facts",
      offer: "Homes",
      offerValue: { one: "{count} apartment in 2 buildings", many: "{count} apartments in 2 buildings" },
      offerFallback: "2 buildings",
      free: "Available",
      price: "Price",
      priceFrom: "from {price}",
      address: "Address",
      addressValue: "Beočinski trg 2 & 4",
    },
    stats: {
      eyebrow: "Track record",
      title: "What we've built",
      items: [
        { value: "90+", label: "homes built" },
        { value: "4,000+", label: "square metres" },
        { value: "30+", label: "happy buyers" },
        { value: "2", label: "residential & commercial buildings" },
      ],
    },
    projects: {
      eyebrow: "Buildings",
      title: "Choose your building",
      lead: "See the available apartments in both buildings on Beočin Square and choose a layout that suits you.",
    },
    featured: {
      eyebrow: "Available now",
      title: "Featured apartments",
    },
    process: {
      eyebrow: "How we build",
      title: "From design to handover",
      lead: "Our team runs construction from the foundations to handover. You can ask us what work is underway and how far along it is.",
      steps: [
        { title: "Design and floor plans", text: "We prepare floor plans for every apartment before construction starts, with practical layouts and bright rooms." },
        { title: "Construction", text: "Our team and trusted tradespeople build to modern standards." },
        { title: "On-site supervision", text: "We run the site and check the schedule and quality of the work ourselves. You speak directly with us, without going through a subcontractor." },
        { title: "Key handover", text: "We clearly set out the price and handover terms in the contract." },
      ],
    },
    about: {
      eyebrow: "About us",
      title: "A family construction company from Beočin",
      lead: "Tehnočin is a family construction company from Beočin. We build with our own team and tradespeople we know. We discuss and agree purchase terms with each buyer.",
      photoAlt: "Tehnočin DOO workers, seen from behind, in front of a building under construction",
      values: [
        { title: "Decades of experience", text: "We have worked in construction for decades. We know how to build apartments well so they last." },
        { title: "Family-run", text: "We stay in touch with buyers from the first call and viewing to the day you get your keys." },
        { title: "Direct from the developer", text: "You get floor plans, prices and purchase terms straight from us, with no agents in between." },
        { title: "Layouts and finishes", text: "Our apartments have practical layouts and bright rooms. We take care with the interior finishes." },
      ],
    },
    reviews: {
      eyebrow: "Reviews",
      title: "What our buyers say",
      rating: "Rated {value} out of 5",
    },
    location: {
      eyebrow: "Location",
      title: "In the centre of Beočin",
      lead: "Both buildings are on Beočin's main square, in the town centre, with everyday amenities nearby. Novi Sad and Fruška Gora National Park are a short drive away.",
      lamelaA: "Beočinski trg 4, Beočin",
      lamelaB: "Beočinski trg 2, Beočin",
      office: "Sales office",
      mapTitle: "Map: Beočinski trg, Beočin",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Questions about buying an apartment",
      items: [
        { q: "Where are the apartments?", a: "Lamela A is at Beočinski trg 4 and Lamela B at Beočinski trg 2, in the centre of Beočin near Novi Sad. Our sales office is at Železnička 11a, Beočin." },
        { q: "How much do the apartments cost?", a: "Prices start at {price} and depend on the apartment, floor and layout. Send an inquiry for the price and purchase terms of the apartment you are interested in." },
        { q: "Am I buying directly from the developer?", a: "Yes. We are the developer, Tehnočin DOO. You buy from us without an agent." },
        { q: "Which layouts are available?", a: "We offer apartments from one room up to five rooms, plus ground-floor commercial units. In the catalogue you can filter by layout, floor and size." },
        { q: "Can I see the apartment before buying?", a: "Yes. Call us on {phone} to arrange a viewing of the building and apartment at a time that suits you." },
        { q: "How can I pay for the apartment?", a: "We agree payment terms with each buyer. Call or send an inquiry to discuss the payment options." },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Book a viewing or request an offer",
      lead: "Send an inquiry for floor plans of available apartments, prices and purchase terms. You can also call us.",
      formTitle: "Send an inquiry",
    },
    modalTitle: "Apartment inquiry",
  },
  catalogue: {
    title: "Apartments for sale",
    titleProject: "{identifier} · {name}",
    breadcrumb: "Breadcrumb",
    all: "All buildings",
    tabs: "Choose a building",
    address: "Beočinski trg 2 & 4, Beočin",
    filters: "Filters",
    reset: "Reset",
    resetFilters: "Reset filters",
    type: "Property type",
    any: "All",
    structure: "Layout",
    floor: "Floor",
    allFloors: "All floors",
    area: "Size",
    allAreas: "All sizes",
    showSold: "Show sold apartments too",
    show: { one: "Show {count} result", many: "Show {count} results" },
    notFound: "Can't find the right apartment?",
    callUs: "Call {phone}",
    results: { one: "{count} unit", many: "{count} units" },
    sort: "Sort",
    sorts: { sprat: "By floor", "povrsina-rastuce": "Size: small → large", "povrsina-opadajuce": "Size: large → small" },
    areas: { "do-40": "up to 40 m²", "40-60": "40 to 60 m²", "60-80": "60 to 80 m²", "80+": "80 m² or more" },
    emptyTitle: "No units match these filters",
    emptyText: "Change the filters or give us a call. Availability changes regularly.",
    priceNote: "{identifier}: prices from {from}{to}. Ask us for the exact price and payment terms.",
    priceTo: " to {price}",
    modalUnit: "Apartment inquiry",
    modalGeneral: "Send an inquiry",
  },
  landing: {
    eyebrow: "New build · Beočin Square",
    title: "New apartments in central Beočin",
    roomRange: "{from} to {to} apartments",
    roomRangeFallback: "Apartments with different layouts",
    priceFrom: "Prices from {price}",
    priceFallback: "Prices on request, direct from the developer",
    checkFree: "Check available apartments",
    stillFree: "{label} left",
    direct: "Buy directly from the developer",
    callNow: "Call now: {phone}",
    messengerText: "Hello, I'm interested in an apartment on Beočinski trg.",
    formTitle: "Send an inquiry",
    formText: "Leave your phone number and we'll send you floor plans and prices of the available apartments.",
    submit: "Send me the offer",
    messagePlaceholder: "e.g. I'm looking for a 2-room apartment on a lower floor",
    reviewBy: "{author}, buyer",
    unitsEyebrow: "Available now",
    unitsTitle: "Apartments for sale",
    prev: "Previous apartments",
    next: "Next apartments",
    railLabel: "Available apartments",
    noUnits: "Call us for the current list of apartments.",
    fullCatalogue: "View all apartments",
    locationTitle: "Beočin Square, Beočin",
    locationText: "Lamela A (Beočinski trg 4) and Lamela B (Beočinski trg 2) are in central Beočin, close to Novi Sad and Fruška Gora.",
    office: "Sales office: {office}",
    schedule: "Book a viewing",
  },
  thanks: {
    title: "Thank you, we've received your inquiry!",
    text: "We'll get back to you soon with floor plans and prices of the available apartments. If it's urgent, give us a call.",
    see: "Browse all apartments",
  },
  notFound: {
    title: "Page not found",
    text: "The link may be outdated or mistyped. Browse our apartments or go back to the home page.",
    home: "Home page",
  },
  form: {
    unitFor: "Inquiry about:",
    interest: "What are you looking for?",
    interestOptions: { Jednosoban: "1-room", Dvosoban: "2-room", "Trosoban i veći": "3 rooms or more", Lokal: "Commercial unit" },
    name: "Full name",
    phone: "Phone",
    phonePlaceholder: "+381 6x xxx xxxx",
    email: "Email",
    message: "Message",
    messagePlaceholder: "Which apartment you're interested in, when you plan to buy…",
    honeypot: "Your website",
    errors: {
      name: "Please enter your full name.",
      phone: "Please enter a valid phone number.",
      email: "This email address isn't valid.",
      message: "Please write a short message.",
    },
    sending: "Sending…",
    submit: "Send inquiry",
    sentTitle: "Thank you, your inquiry has been sent!",
    sentText: "We'll get back to you as soon as we can.",
    failed: "Sending failed. Please try again or call us on",
    privacy: "We only use your details to reply to your inquiry.",
  },
  unit: {
    status: { slobodan: "Available", rezervisan: "Reserved", prodat: "Sold" },
    types: { stan: "Apartment", lokal: "Commercial unit", garaža: "Parking space" },
    struktura: {
      "0.5": "Studio",
      "1": "1-room",
      "1.5": "1.5-room",
      "2": "2-room",
      "2.5": "2.5-room",
      "3": "3-room",
      "3.5": "3.5-room",
      "4": "4-room",
      "5": "5-room",
    },
    rooms: "{count} rooms",
    strukturaPlural: {
      "0.5": "studio",
      "1": "1-room",
      "1.5": "1.5-room",
      "2": "2-room",
      "2.5": "2.5-room",
      "3": "3-room",
      "3.5": "3.5-room",
      "4": "4-room",
      "5": "5-room",
    },
    floors: { "-1": "Lower ground floor", "0": "Ground floor", n: "Floor {n}", attic: "Attic", atticOf: "Attic ({floor})" },
    floorNumeric: "Floor {n}",
    priceOnRequest: "Price on request",
    viewPlan: "View floor plan: {title}",
    planSoon: "{title}: floor plan coming soon",
    planAlt: "Floor plan: {title}",
    planPlaceholder: "Floor plan coming soon",
    sold: "Sold",
    inquire: "Inquire",
  },
  project: {
    freeFlats: { one: "{count} apartment available", many: "{count} apartments available" },
    freeShops: { one: "{count} commercial unit available", many: "{count} commercial units available" },
    soldPct: "{pct}% sold",
    soldAria: "{pct}% of apartments sold",
    price: "Price",
    shops: "Commercial",
    soldOut: "Sold out",
    floors: "Storeys",
    floorsValue: "{count} storeys",
    photosSoon: "Photos coming soon",
    seeUnits: "View apartments",
  },
  footer: {
    tagline: "A family construction company from Beočin. Buy your apartment directly from us.",
    site: "Site",
    contact: "Contact",
    follow: "Follow us",
    office: "Office: {office}",
    rights: "All rights reserved.",
  },
  gallery: {
    label: "Gallery",
    close: "Close gallery",
    prev: "Previous photo",
    next: "Next photo",
    photo: "Photo",
    of: "{n} of {total}",
    enlarge: "Enlarge photo: {alt}",
  },
  seo: {
    siteName: "Tehnočin DOO",
    home: {
      title: "New apartments in Beočin, near Novi Sad | Tehnočin",
      description: "New-build apartments on Beočin Square near Novi Sad, Serbia. Lamela A & B: floor plans and prices from 1,200 €/m², direct from the developer.",
    },
    catalogue: {
      title: "Apartments for sale in Beočin, Serbia | Tehnočin",
      description: "All available apartments and commercial units on Beočin Square near Novi Sad. Filter by layout, floor and size, view floor plans and send an inquiry.",
    },
    catalogueProject: {
      title: "{identifier}: apartments for sale, Beočin | Tehnočin",
      description: "{identifier}, {address}: available apartments, floor plans and prices. New build in central Beočin near Novi Sad, direct from developer Tehnočin DOO.",
    },
    landing: {
      title: "New apartments in central Beočin | Tehnočin",
      description: "Apartments from one to five rooms on Beočin Square near Novi Sad. Leave your number and we'll send floor plans and prices of available units.",
    },
    thanks: { title: "Thank you | Tehnočin DOO", description: "Your inquiry has been received." },
    notFound: { title: "Page not found | Tehnočin DOO", description: "The page you requested doesn't exist. Browse new apartments on Beočin Square or go back to the home page." },
    breadcrumbHome: "Home",
    breadcrumbUnits: "Apartments",
  },
};

export default en;
